import { EmptyCaseIconWithDescription } from '~/@pages/@common/EmptyCase'

export const EmptyCaseInStudentWorksheetList = () => {
  return (
    <EmptyCaseIconWithDescription>
      <p>학습지가 없습니다.</p>
    </EmptyCaseIconWithDescription>
  )
}
